import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const res = await api.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        // Clear the fragment, then go to dashboard.
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", {
          replace: true,
          state: { user: res.data.user },
        });
      } catch (err) {
        console.error("Auth session exchange failed", err);
        navigate("/login", { replace: true, state: { error: "auth_failed" } });
      }
    };
    run();
  }, [navigate]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-stone-50"
      data-testid="auth-callback-loading"
    >
      <SEO noindex title="Signing in… — Beyond Valencia" canonical="/auth-callback" />
      <div className="text-stone-700 text-sm tracking-wide">
        Finishing sign-in…
      </div>
    </div>
  );
}
